export enum ArticleOverviewSectionType {
  media = 1,
  textBlock = 2,
  oeNumbers = 3,
  crossCompetitorsNumbers = 4,
  linkageTargets = 5,
  aceLinkageTargets = 6,
  globalIdentifiers = 7,
  partList = 8,
  accessoryList = 9,
  partsOf = 10,
  tradeNumbers = 11,
  supersededBy = 12,
  supersedes = 13,
  packaging = 14,
  prices = 15,
  attributes = 16,
  statuses = 17,
  additionalInformation = 18,
  pmMemo = 19,
  history = 20,
  vio = 21,
  accessoryOf = 22,
  customLinkageTargets = 23,
}
